import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface IInviteFormData {
  id: string
  customerId: string
  invitedName: string
  invitedEmail: string
  token: string
}

const InviteSchema: JSONSchemaType<IInviteFormData> = {
  type: 'object',
  properties: {
    customerId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    invitedName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    invitedEmail: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'E-mail inválido.',
    },
    token: {
      type: 'string',
    },
    id: {
      type: 'string',
    },
  },
  required: ['customerId', 'invitedName', 'invitedEmail'],
  additionalProperties: false,
}

export default InviteSchema
